<ng-container *ngIf="router.url != '/login' && router.url != '/'">
  <app-header (valueChanged)="handleSidebar($event)" />
  <mat-sidenav-container class="example-container" [hasBackdrop]="sideNavMode === 'over'">
    <mat-sidenav #sideNav [fixedInViewport]="true" [fixedTopGap]="68" [mode]="sideNavMode" [(opened)]="isOpenToggle">
      <div class="col-md-12 no-padding">
        <div class="userprofile">
          <span> Logged in as </span>
          <span class="User"> {{userName}} </span>
        </div>
      </div>
      <div class="col-md-12 no-padding">
        <div class="stemi-main-menus">
          <ul>
            <li *ngIf="userType === 'SA'">
              <a [routerLink]="['/instance-management']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/menu-white-instance-management.png" class="clr-white" />
                  <img src="/images/menu-gray-instance-management.png " class="clr-gray" />
                  <span>Instance Management</span>
                </div>
              </a>
            </li>
            
            <li *ngIf="userType !== 'SA'">
              <a [routerLink]="['/patient-list']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/menu-white-patient-record.png" class="clr-white" />
                  <img src="/images/menu-gray-patient-record.png" class="clr-gray" />
                  <span>Patient Management</span>

                </div>
              </a>
            </li>
            <li *ngIf="userType === 'admin' || userType === 'hospitalUser'">
              <a [routerLink]="['/ecg-records']" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/offline-white.png" class="clr-white" />
                  <img src="/images/offline.png" class="clr-gray" />
                  <span>ECG Records</span>

                </div>
              </a>
            </li>
            <li *ngIf="userType === 'admin'">
              <a [routerLink]="['/location-management']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/menu-white-location-management.png" class="clr-white" />
                  <img src="/images/menu-gray-location-management.png" class="clr-gray" />
                  <span>Location Management</span>

                </div>
              </a>
            </li>
            <li *ngIf="userType === 'admin'">
              <a [routerLink]="['/hospital-management']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/menu-white-hospital-management.png" class="clr-white" />
                  <img src="/images/menu-gray-hospital-management.png" class="clr-gray" />
                  <span>Hospital Management</span>
                </div>
              </a>
            </li>
            <li *ngIf="userType === 'admin'">
              <a [routerLink]="['/cluster-management']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/menu-white-cluster-management.png" class="clr-white" />
                  <img src="/images/menu-gray-cluster-management.png" class="clr-gray" />
                  <span>Cluster Management</span>
                </div>
              </a>
            </li>
            <li *ngIf="userType === 'admin'">
              <a [routerLink]="['/cluster-mapping']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/menu-white-cluster-mapping.png" class="clr-white" />
                  <img src="/images/menu-gray-cluster-mapping.png" class="clr-gray" />
                  <span>Cluster Mapping</span>
                </div>
              </a>
            </li>
            <li *ngIf="userType === 'SA' || userType === 'admin'">
              <a [routerLink]="['/user-management']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/menu-white-instance-management.png" class="clr-white" />
                  <img src="/images/menu-gray-instance-management.png " class="clr-gray" />
                  <span>User Management</span>
                </div>
              </a>
            </li>
            <li *ngIf="userType === 'admin'">
              <a [routerLink]="['/device-management']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/device-white.png" class="clr-white" />
                  <img src="/images/device-gray.png" class="clr-gray" />
                  <span>Device Management</span>
                </div>
              </a>
            </li>
            <li *ngIf="userType === 'admin'">
              <a [routerLink]="['/control-panel']" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <div class="menu-list">
                  <img src="/images/control-panel-white.png" class="clr-white" />
                  <img src="/images/control-panel-gray.png" class="clr-gray" />
                  <span>Control Panel</span>
                </div>
              </a>
            </li>

            <!-- LogOut -->
            <li class="mbl-menu log-out">
              <a (click)="logOut()">
                <div class="menu-list">
                  <img src="/images/menu-white-logout.png" class="clr-white" />
                  <img src="/images/menu-gray-logout.png" class="clr-gray" />
                  <span>LogOut</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content [ngStyle]="{
      padding: userLoggedIn ? '20px 30px 30px 30px' : '0px',
      'margin-top': userLoggedIn ? '50px' : '0px',
      'margin-left': sideNavMode === 'side' && isOpenToggle ? '240px' : '0px'
    }" [ngClass]="{ 'override-margin-left': sideNavMode === 'side' && isOpenToggle }">
      <router-outlet></router-outlet>
    </mat-sidenav-content>

  </mat-sidenav-container>
</ng-container>

<ng-container *ngIf="
    router.url == '/login' ||
    router.url == '/' ||
    router.url == '/signup-clinic'
  ">
  <router-outlet></router-outlet>
</ng-container>